import { trackKnownAnalyticsEvent } from "../analyticsClient";
import {
  buildComicDetailViewParams,
  buildReleaseDetailViewParams,
  ComicDetailViewParamsInput,
  ReleaseDetailViewParamsInput,
} from "../params/navigation";

export function trackComicDetailView(params: ComicDetailViewParamsInput): void {
  trackKnownAnalyticsEvent("comic_detail_view", buildComicDetailViewParams(params));
}

export function trackReleaseDetailView(params: ReleaseDetailViewParamsInput): void {
  trackKnownAnalyticsEvent("release_detail_view", buildReleaseDetailViewParams(params));
}
